export const contactData = {
    text: `I'm always open to discussing Software Engineer and Frontend Engineer opportunities, exciting projects, or potential collaborations. If you have a role or project that matches my skills, feel free to get in touch.`,

    socialAccounts: [
        {
            id: 1,
            name: "Email",
            icon: require("../assets/Icon/email.svg").default, // অথবা mail.svg
            link: "abdulkadirshohan@gmail.com",
            text: "abdulkadirshohan@gmail.com",
            isEmail: true,
        },
        {
            id: 2,
            name: "LinkedIn",
            icon: require("../assets/Icon/linkedin.svg").default,
            link: "https://linkedin.com/in/abdulkadershohan",
            text: "linkedin.com/in/abdulkadershohan",
            isEmail: false,
        },
        {
            id: 3,
            name: "GitHub",
            icon: require("../assets/Icon/github.svg").default,
            link: "https://github.com/abdulkadershohan",
            text: "github.com/abdulkadershohan",
            isEmail: false,
        },
    ],

    socialAccountsTitle: "Let's Connect",
};